import {
  RoutePairTargetQuery,
  RoutePairTargetQueryVariables,
} from "@/gql/graphql";
import { gql, useLazyQuery } from "@apollo/client";
import { customerTargetActions } from "../redux/reducers";
import { transformRoutPairTargetQueryToAllCustomerTargetsTableRow } from "../../../transformers/TargetRoutePairTransformers";
import { useDispatch } from "react-redux";

export const fetchRoutePairCustomerTargetFragment = gql`
  fragment FetchRoutePairCustomerTarget on TargetRoutePair {
    id
    year
    routePairCode
    customerCategory {
      code
      description
    }
    customerName
    seller
    custNo
    salesRegion {
      id
      code
      shortName
    }
    unitCategoryCode
    statNo
    statNetworkVolume
    statRouteVolume
    statRouteRowVolume
    custNetworkVolume
    custRouteVolume
    custRouteRowVolume
    avgGrossMeterPrice
    avgNetMeterPrice
    targetInPercent
    sailingCategory {
      id
      code
      name
    }
    customerCountry {
      id
      code
      name
    }
  }
`;
const routePairTargetQuery = gql`
  ${fetchRoutePairCustomerTargetFragment}
  query RoutePairTarget($filter: TargetRoutePairInput!) {
    productPrice {
      targetRoutePair {
        byFilter(filter: $filter) {
          items {
            ...FetchRoutePairCustomerTarget
          }
        }
      }
    }
  }
`;

export const useFetchCustomerRoutePairTargets = () => {
  const dispatch = useDispatch();
  const [fetchCustomerRoutePairTargetList, { loading, error }] = useLazyQuery<
    RoutePairTargetQuery,
    RoutePairTargetQueryVariables
  >(routePairTargetQuery, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      const targetRoutePairs = data.productPrice.targetRoutePair.byFilter.items;
      if (targetRoutePairs) {
        dispatch(
          customerTargetActions.setState(
            targetRoutePairs.map((targetRoutepair) =>
              transformRoutPairTargetQueryToAllCustomerTargetsTableRow(
                targetRoutepair
              )
            )
          )
        );
      }
    },
  });

  return {
    fetchCustomerRoutePairTargetList,
    loading,
    error,
  };
};
